import React, { useEffect, useState } from 'react';
import { Alert, Card, Offcanvas } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import useChatPanelStore from 'stateManagement/store/useChatPanelStore';

import { ORG_SERVICES } from 'blockscope/static/blockscopeServices';

import PanelContent from './components/PanelContent';
import PanelHeader from './components/PanelHeader';

const ChatPanel = ({ orgReducer: { orgDetails } }) => {
  const location = useLocation();

  const [isEnabled, setIsEnabled] = useState(false);
  const showChatPanel = useChatPanelStore((state) => state.showChatPanel);
  const setShowChatPanel = useChatPanelStore((state) => state.setShowChatPanel);

  useEffect(() => {
    // Enable the panel if orgId exists and path is not landing page
    if (
      location.pathname !== '/' &&
      location.pathname !== '' &&
      orgDetails?.org
    ) {
      setIsEnabled(orgDetails?.org.orgServices.includes(ORG_SERVICES.AI_CHAT));
    } else {
      setIsEnabled(false);
    }
  }, [orgDetails, location.pathname]);

  return (
    <>
      {isEnabled ? (
        <Card
          className='setting-toggle'
          onClick={() => {
            setShowChatPanel(true);
          }}
          style={{
            height: '40px',
            transform: 'rotate(-90deg) translateY(25px) translateX(110px)',
          }}
        >
          <Card.Body className='d-flex align-items-center px-2 me-1 ms-1 mb-1 py-2'>
            <span className='text-900 fw-medium fs--1 me-2 text-uppercase'>
              Ask AI
            </span>
            <FontAwesomeIcon
              // @ts-ignore (Fa BS)
              icon='brain'
              // style={{ transform: 'rotate(90deg)' }}
            />
          </Card.Body>
        </Card>
      ) : null}

      <Offcanvas
        show={showChatPanel}
        onHide={() => setShowChatPanel(false)}
        placement='end'
        style={{ width: '55rem' }}
        className='border-0'
      >
        <Offcanvas.Header closeButton className='bg-300'>
          {isEnabled ? <PanelHeader /> : null}
        </Offcanvas.Header>
        <Offcanvas.Body
          className='scrollbar chat-panel-body'
          id='chat-panel-container'
        >
          {isEnabled ? (
            <PanelContent />
          ) : (
            <Alert>
              <Alert.Heading>
                AI Chat is not enabled for this organization
              </Alert.Heading>
              Contact Blockscope support to enable this feature
            </Alert>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

ChatPanel.propTypes = {
  orgReducer: PropTypes.object,
};

const mapStateToProps = (state) => ({
  orgReducer: state.orgReducer,
});

export default connect(mapStateToProps, {})(ChatPanel);

